import { ADMIN_BANNER_CLICK, ADMIN_BANNER_IMP, GET_FLOW_BUILDER_BANNERS, getSubscriptionDetailsResponseBody, GET_SUBSCRIBER, UpdateOrDeleteResponseBody, updateSubscriptionResponseBody } from "../utils/constant";
import { getJson, postJson, putJson } from "../utils/network";

export async function getFlowBuilderBanner() {
  const { response } = await getJson<UpdateOrDeleteResponseBody>(GET_FLOW_BUILDER_BANNERS);

  return response;
}
export async function countAdminBannerClick(data: any) {
  const { response } = await postJson<UpdateOrDeleteResponseBody>(ADMIN_BANNER_CLICK,data);

  return response;
}
export async function countAdminBannerImp(data: any) {
  const { response } = await postJson<UpdateOrDeleteResponseBody>(ADMIN_BANNER_IMP,data);

  return response;
}

export const updateSubscription = async (data: any) => {
  const { response } = await putJson<updateSubscriptionResponseBody>(GET_SUBSCRIBER, data);

  return response;
};

export const getSubscriptionDetails = async (data: any) => {
  const { response } = await getJson<getSubscriptionDetailsResponseBody>(GET_SUBSCRIBER, data);

  return response;
};


